import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrar Service Worker para PWA.
// Solo en la web: dentro del contenedor nativo de Capacitor (capacitor://localhost
// en iOS, http://localhost en Android) el SW no es fiable, los assets ya son
// locales y podria interferir dejando contenido pegado. La deteccion de offline
// sigue funcionando porque un fetch nativo sin red lanza el mismo "Failed to fetch"
// que api.ts ya captura.
if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registrado:', registration.scope);

        // Comprobar actualizaciones periodicamente
        setInterval(() => registration.update(), 60 * 60 * 1000); // cada hora

        registration.onupdatefound = () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.onstatechange = () => {
              if (newWorker.state === 'activated') {
                // Notificar que hay una nueva version disponible
                if (navigator.serviceWorker.controller) {
                  console.log('Nueva version de MalDolor disponible');
                }
              }
            };
          }
        };
      })
      .catch((error) => {
        console.error('Error registrando SW:', error);
      });
  });
}

reportWebVitals();
